const initialState = {}

const landingPage = (state = initialState, {type, payload}) => {
  switch (type) {
    case 'LANDING_PAGE.INIT':
      return {...state, ...payload}
    default:
      return state
  }
}

export default landingPage
